const update_type = {
    delete: 'DELETE',
    update: 'UPDATE',
    create: "CREATE"
}

export default update_type